<template>
<div>
<div class="homeLandingLogin"></div>
  <div v-if="loading" class="row align-middle mt-5">
    <div class="col-sm-4 login spinspin">
      <h2 class="text-center">Authorizing...</h2>
    </div>
  </div>
  <div v-else class="row align-middle">
    <div class="col-md-8 col-lg-3 mt-5 login">
      <h2>Log In</h2>
      <div class="alert alert-danger" v-if="error">
        <p>{{ error }}</p>
      </div>
      <b-form @submit.prevent="submit" autocomplete="off">
      <div class="form-group">
        <p class="control has-icon has-icon-right">
        <input
          type="text"
          name="Login Email"
          class="form-control"
          placeholder="Enter your username email"
          v-model="credentials.username"
          @input="credentials.username = credentials.username.trim()"
          v-validate="'required|email'"
          data-vv-delay="20000"
          :class="{'input': true, 'is-danger': errors.has('Account Name') }"/>
        <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('Login Email')" class="fa-1x"></font-awesome-icon>
        <span v-show="errors.has('Login Email')" class="help is-danger">{{ errors.first('Login Email') }}</span>
        </p>
      </div>
      <div class="form-group">
        <input
          :type="passwordFieldType"
          class="form-control"
          placeholder="Enter your password"
          v-model="credentials.password"
        >

        <font-awesome-icon v-if="this.passwordFieldType==='password'" icon="eye" class="field-icon" @click="switchVisibility"></font-awesome-icon>
        <font-awesome-icon v-else icon="eye-slash" class="field-icon" @click="switchVisibility"></font-awesome-icon>
      </div>
      <div class="row">
        <div class="col-md-6">
          <button class="btn btn-primary" type="submit">Login</button>
        </div>
        <div class="col-md-6">
          <router-link to="/passwordreset">Reset Password</router-link>
        </div>
      </div>
      <div class='row'>
      <div class='col mt-3' >
        <p :class='sentClass'>{{message}}</p>
      </div>
    </div>
      </b-form>
    </div>
  </div>

</div>
</template>

<script>
import auth from './auth'
export default {
  name: 'Login',
  data: function () {
    return {
      // We need to initialize the component with any
      // properties that will be used in it
      credentials: {
        username: '',
        password: ''
      },
      error: '',
      timer: '',
      countingTheBeat: 0,
      loading: false,
      passwordFieldType: 'password',
      message: '',
      sentClass: ''
    }
  },
  methods: {
    submit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true
          var splitItUp = this.credentials.username.split('@')
          splitItUp[1] = splitItUp[1].toLowerCase()
          this.credentials.username = splitItUp[0] + '@' + splitItUp[1]
          var credentials = {
            username: this.credentials.username,
            password: this.credentials.password
          }
          // We need to pass the component's this context
          // to properly make use of http in the auth service
          auth.login(this, credentials, 'contracts')
          this.message = ''
          if (!auth.user.authenticated) {
            this.loading = false
            this.sentClass = 'text-danger'
            this.timer = setTimeout(() => { this.clearData() }, 10000)
          }
        }
      })
    },
    switchVisibility () {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    clearData () {
      this.message = ''
      this.loading = false
      this.credentials.username = ''
      this.credentials.password = ''
      this.error = ''
      this.$validator.pause()
      this.$nextTick(() => {
        this.$validator.errors.clear()
        this.$validator.fields.items.forEach(field => field.reset())
        this.$validator.fields.items.forEach(field => this.errors.remove(field))
        this.$validator.resume()
      })
    }
  }
}
</script>

<style>
.login {
  margin: 0 auto;
  border: solid 1px #bbbbbb;
  padding:30px 40px;
  border-radius: 5px;
  background-color: #eeeeee;
}
.spinspin {
  height:254px;
}
.spinner {
  margin: 30px auto 20px auto ;
}
body {
  background: rgba(0,123,255,1);
  background: -moz-linear-gradient(top, rgba(0,123,255,1) 0%, rgba(26,26,96,1) 100%);
  background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(0,123,255,1)), color-stop(100%, rgba(26,26,96,1)));
  background: -webkit-linear-gradient(top, rgba(0,123,255,1) 0%, rgba(26,26,96,1) 100%);
  background: -o-linear-gradient(top, rgba(0,123,255,1) 0%, rgba(26,26,96,1) 100%);
  background: -ms-linear-gradient(top, rgba(0,123,255,1) 0%, rgba(26,26,96,1) 100%);
  background: linear-gradient(to bottom, rgba(0,123,255,1) 0%, rgba(26,26,96,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#007bff', endColorstr='#1a1a60', GradientType=0 );
  background-repeat: no-repeat;
    background-attachment: fixed;
}
.field-icon {
  float: right;
  margin-right: 10px;
  margin-top: -25px;
  position: relative;
  z-index: 2;
  fill: rgba(0,0,0,0.65);
  cursor:pointer;
  color: #666666;
}
.homeLandingLogin {
    width: 100%;
    background-image: url(/static/pawnee-portal-landing-2.jpg);
    background-color: rgba(255, 255, 255, 1) !important;
    background-blend-mode: luminosity;
    background-repeat: no-repeat;
    left: 0;
    height: 100%;
    top: 0px;
    background-size: cover;
    background-position: center;
    overflow: hidden;
    opacity: 0.4;
    position:fixed;
    z-index: -1;
}
</style>



// WEBPACK FOOTER //
// src/login.vue